module.exports = __webpack_public_path__ + "img/Card_heart_J.b99af560.svg";